const HERO_IMG =
  "https://images.unsplash.com/photo-1618551763300-dc7eb8ce3560?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxwaWNrbGViYWxsfGVufDB8fHx8MTc4MTU0OTI1MXww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" data-testid="hero-section" className="relative">
      {/* Top spec bar */}
      <div className="border-b border-[#E5E5E5] bg-white">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 h-9 flex items-center justify-between text-[11px] font-mono-bb text-[#525252]">
          <span>● MFG_001 · ENGINEERED IN THE USA · ON-DEMAND PRODUCTION</span>
          <span className="hidden sm:inline">EST. 2025 / B2B PICKLEBALL HARDWARE</span>
        </div>
      </div>

      <div className="relative grid grid-cols-1 lg:grid-cols-12 border-b border-[#E5E5E5]">
        {/* Left text column */}
        <div className="lg:col-span-7 px-6 md:px-12 lg:px-16 pt-16 pb-20 lg:pt-24 lg:pb-32 border-r border-[#E5E5E5] bg-[#FAFAFA] relative">
          <div className="bb-fade-up">
            <div className="overline text-[#525252] mb-6">
              <span className="inline-block w-6 h-px bg-[#0A0A0A] align-middle mr-3" />
              B2B Pickleball Accessories · 3D Printed
            </div>

            <h1 className="font-display text-5xl sm:text-6xl lg:text-[88px] leading-[0.95] tracking-[-0.035em] font-medium">
              Hardware
              <br />
              built for the
              <br />
              <span className="relative inline-block">
                <span className="relative z-10">facility floor.</span>
                <span className="absolute bottom-1 left-0 right-0 h-3 bg-[#DFFF00] -z-0" />
              </span>
            </h1>

            <p className="mt-8 max-w-xl text-[16px] leading-relaxed text-[#525252]">
              The Ball Boss designs and produces durable, on-demand 3D printed
              accessories for pickleball facilities across the United States —
              from magnetic ball holders to court numbering systems.
              <span className="text-[#0A0A0A] font-medium"> Tailored to you.</span>
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-cta-quote"
                onClick={() => scrollTo("#quote")}
                className="group inline-flex items-center gap-3 bg-[#DFFF00] text-[#0A0A0A] px-7 py-4 text-[13px] font-semibold tracking-wide uppercase hover:bg-[#0A0A0A] hover:text-white transition-colors"
              >
                Request a Facility Quote
                <i className="fa-solid fa-arrow-right text-[12px] group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                data-testid="hero-cta-products"
                onClick={() => scrollTo("#products")}
                className="inline-flex items-center gap-3 border border-[#0A0A0A] px-7 py-4 text-[13px] font-semibold tracking-wide uppercase hover:bg-[#0A0A0A] hover:text-white transition-colors"
              >
                View the Catalog
              </button>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg border-t border-[#E5E5E5] pt-8">
              {[
                { k: "100%", v: "Made-to-Order" },
                { k: "48h", v: "Avg. Lead Time" },
                { k: "USA", v: "Domestic Production" },
              ].map((s) => (
                <div key={s.v}>
                  <div className="font-display text-3xl font-medium">{s.k}</div>
                  <div className="overline text-[#525252] mt-2">{s.v}</div>
                </div>
              ))}
            </div>
          </div>

          {/* corner ticks */}
          <CornerTicks />
        </div>

        {/* Right image column */}
        <div className="lg:col-span-5 relative min-h-[360px] lg:min-h-0">
          <img
            src={HERO_IMG}
            alt="Pickleball court"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30" />
          <div className="absolute inset-0 p-8 md:p-12 flex flex-col justify-between text-white">
            <div className="flex items-center justify-between">
              <span className="font-mono-bb text-[11px] tracking-widest">
                FILE / HERO_01.JPG
              </span>
              <span className="font-mono-bb text-[11px]">N 38.9° / W 77.0°</span>
            </div>
            <div>
              <div className="font-mono-bb text-[11px] tracking-widest mb-2 text-[#DFFF00]">
                CURRENTLY IN PRODUCTION
              </div>
              <div className="font-display text-2xl tracking-tight max-w-sm">
                The Ballboy · Magnetic Net-Post Ball Holder
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function CornerTicks() {
  return (
    <>
      <span className="absolute top-0 left-0 w-2 h-2 border-t border-l border-[#0A0A0A]" />
      <span className="absolute top-0 right-0 w-2 h-2 border-t border-r border-[#0A0A0A]" />
      <span className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-[#0A0A0A]" />
      <span className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-[#0A0A0A]" />
    </>
  );
}
